/**
 * A simple fetch utility that parses any successful HTTP response as text
 */
export function fetchText(url, options = {}) {
    return fetch(url, { headers: { Accept: "text/plain" }, ...options })
        .then(response => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            return response.text();
        });
}

/**
 * Appends additional search params to a url that already contains existing search params
 */
export function withAdditionalSearchParams(url, message = {}) {
    const search = new URLSearchParams(Object.entries(message)).toString();
    return url + (search ? "&" + search : "");
}